import CheckList from "./CheckList";
import NewJoinerCard from "./NewJoinerCard";
import TaskList from "./TaskList";
import TaskProgress from "./TaskProgress";
import ActivityAssign from "./ActivityAssign/ActivityAssign";
import CalendarAndCountDown from "./CalendarAndCountDown/index";
import InformationNewJoiner from "./InformationNewJoiner/InformationNewJoiner";
import DeviceInfo from "./DeviceInfo/DeviceInfo";
import ProductivitySection from "./ProductivitySection/ProductivitySection";
import ELearningSection from "./ELearningSection/ELearningSection";
import OnboardingForm from "./OnboardingForm";

const OnBoardingComponent = {
  CheckList,
  NewJoinerCard,
  TaskList,
  TaskProgress,
  ActivityAssign,
  CalendarAndCountDown,
  InformationNewJoiner,
  DeviceInfo,
  ProductivitySection,
  ELearningSection,
  OnboardingForm
};

export default OnBoardingComponent